import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { debounce, map } from "lodash"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { MetaTags } from "react-meta-tags"
import {
  Container,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
} from "reactstrap"
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  CardTitle,
  FormGroup,
  Spinner,
} from "reactstrap"
import Select from "react-select"
import CreatableSelect from "react-select/creatable"
import classnames from "classnames"

//actions
import {
  getClients,
  createQuatation,
  updateQuatation,
  getProducts,
  getQProductPrice,
  getQuotationDetail,
  getBankDetails,
} from "store/actions"

import Breadcrumbs from "../../../../components/Common/Breadcrumb"

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import FormEditors from "./Editor"
import { Notification } from "components/Common/Notification"
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min"
import EditModal from "./EditModal"
import { get } from "helpers/api_methods"

const UpdateQuotations = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()

  // Get quotation ID from URL params (could be 'id' or other param name)
  const quotationId = params.id || params.quotationId || Object.values(params)[0]

  console.log("All URL params:", params)
  console.log("Extracted quotation ID:", quotationId)
  //redux state
  const {
    loading,
    quotationLoading,
    clients,
    products,
    QProductPrice,
    quotationCurd,
    bankDetailsData,
    quoteDetails,
  } = useSelector(state => ({
    loading: state.StoreItems.loading,
    quotationLoading: state.Orders.quotationLoading,
    clients: state.Clients.clients,
    products: state?.Products?.products?.results,
    QProductPrice: state.Orders.QProductPrice,
    quotationCurd: state.Orders.quotationCurd,
    bankDetailsData: state.Orders.bankDetails,
    quoteDetails: state?.Orders?.quotationDetails,
  }))
  const [selectedProductId, setSelectedProductId] = useState([])
  const [selectedProduct, setSelectedProduct] = useState("")
  const [selectedClient, setSelectedClient] = useState("Search a Client")
  const [selectedClientId, setSelectedClientId] = useState("")
  const [isOpen, setIsOpen] = useState({ status: false, data: "", client: "" })
  const [selectedDocumentType, setSelectedDocumentType] = useState({
    key: 1,
    label: "Quotation",
    value: "quotation",
  })
  const [selectedQuotationCategory, setSelectedQuotationCategory] = useState({
    key: 1,
    label: "Product",
    value: "product",
  })
  const [staffList, setStaffList] = useState([])
  const [selectedCareOf, setSelectedCareOf] = useState(null)

  const replaceCareOfNameInLetterHead = (currentLetterHead, newName) => {
    if (!currentLetterHead) return currentLetterHead
    const targetName = newName || "__________"
    const regex = /As per your discussion with [^,.<>]+/i
    if (regex.test(currentLetterHead)) {
      return currentLetterHead.replace(regex, `As per your discussion with ${targetName}`)
    } else if (currentLetterHead.includes("As per your discussion with")) {
      return currentLetterHead.replace(/As per your discussion with/i, `As per your discussion with ${targetName}`)
    }
    return currentLetterHead
  }

  const getStaffDisplayName = (option) => {
    if (!option) return "__________"
    if (option.staffName) return option.staffName
    const labelParts = option.label ? option.label.split(' (') : []
    return labelParts[0] ? labelParts[0].trim() : "__________"
  }

  const handleCareOfChange = (selectedOption) => {
    setSelectedCareOf(selectedOption)
    const staffName = getStaffDisplayName(selectedOption)
    setLetterHead(prev => replaceCareOfNameInLetterHead(prev, staffName))
  }

  console.log(selectedProduct)

  const [searchText, setSearchText] = useState("")
  const [searchClientText, setSearchClientText] = useState("")
  const [qty, setQty] = useState(1)
  const [discountPrice, setDiscountPrice] = useState(0)
  const [taxAmount, setTaxAmount] = useState(0)
  const [rowDiscountPercentage, setRowDiscountPercentage] = useState(0)
  const [rowTaxPercentage, setRowTaxPercentage] = useState(0)
  const [contact_person, setContact_person] = useState("")
  const [contact_person_phone, setContact_person_phone] = useState("")
  const [discount, setDiscount] = useState(0)
  const [taxPercentage, setTaxPercentage] = useState(18)
  const [currentMrp, setCurrentMrp] = useState(0)

  const [quotationitem, setQuotationitems] = useState([])
  const [rawData, setRawData] = useState({
    client: "",
    quotationitem: [],
  })

  //EDITOR
  const [letter_head, setLetterHead] = useState(
    `<p><strong>Dear Sir/Madam,</strong></p><p></p>`
  )
  const [bank_details, setBankDetails] = useState(bankDetailsData?.bank_details)
  const [terms, setTerms] = useState(bankDetailsData?.trems_and_conditions)
  const [letter_middle, setLetter_middle] = useState("")
  const [totalPrice, setTotalPrice] = useState(0)
  const [warrenty, setWarrantyClause] = useState(
    bankDetailsData?.warrenty_clauses
  )

  // Additional fields for complete payload
  const [status, setStatus] = useState("pending")
  const [isDuplicate, setIsDuplicate] = useState(false)
  const [editingItemId, setEditingItemId] = useState(null)

  const [activeTab, setactiveTab] = useState({
    id: "1",
  })

  console.log(QProductPrice)

  useEffect(() => {
    // Only set defaults if no quoteDetails data exists to avoid overwriting historical edits
    if (!quoteDetails || Object.keys(quoteDetails).length === 0) {
      setBankDetails(bankDetailsData?.bank_details)
      setTerms(bankDetailsData?.trems_and_conditions)
      setWarrantyClause(bankDetailsData?.warrenty_clauses)
    }
  }, [bankDetailsData])

  useEffect(() => {
    if (quotationId) {
      console.log("Loading quotation details for ID:", quotationId)
      dispatch(getBankDetails())
      dispatch(getQuotationDetail(quotationId))
      // Load initial clients and products data
      dispatch(getClients("", ""))
      dispatch(getProducts(""))
      fetchStaff()
    }
  }, [dispatch, quotationId])

  const fetchStaff = async () => {
    try {
      const res = await get("/account/staff/")
      if (Array.isArray(res)) {
        setStaffList(res)
      } else if (res && res.results) {
        setStaffList(res.results)
      }
    } catch (err) {
      console.error("Failed to fetch staff list", err)
    }
  }

  useEffect(() => {
    if (quoteDetails) {
      console.log("Loading quotation data:", quoteDetails)

      // Basic client information - set in correct format for Select component
      setSelectedClient({
        label: quoteDetails?.client_name || "",
        value: quoteDetails?.client || ""
      })
      setSelectedClientId(quoteDetails?.client || "")

      // Product information
      // setSelectedProduct(
      //   quoteDetails?.quotationitem?.map(item => item?.product_name) || []
      // )
      // setSelectedProductId(
      //   quoteDetails?.quotationitem?.map(item => item?.product) || []
      // )

      // Contact information
      setContact_person(quoteDetails?.contact_person || "")
      setContact_person_phone(quoteDetails?.contact_person_phone || "")

      // Financial information
      setDiscount(quoteDetails?.discount_percentage || "")

      // Editor content fields

      console.log(quoteDetails?.letter_head);

      setLetterHead(quoteDetails?.letter_head || `<p><strong>Dear Sir/Madam,</strong></p><p></p>`)
      setLetter_middle(quoteDetails?.letter_middle || "")
      setBankDetails(quoteDetails?.bank_details || "")
      setTerms(quoteDetails?.terms || "")
      setWarrantyClause(quoteDetails?.warrenty || "")

      // Additional payload fields
      setStatus(quoteDetails?.status || "pending")
      setTaxPercentage(quoteDetails?.tax_percentage || "18.00")
      setIsDuplicate(quoteDetails?.isDuplicate || false)

      // Quotation items
      setQuotationitems(quoteDetails?.quotationitem || [])

      // Set quantity if there's a single item (for UI display)
      // if (quoteDetails?.quotationitem && quoteDetails.quotationitem.length === 1) {
      //   setQty(quoteDetails.quotationitem[0]?.qty || 1)
      // }

      // Calculate total price from quotation items
      const totalMrp = quoteDetails?.quotationitem?.reduce((sum, item) =>
        sum + parseFloat(item?.mrp_sub_total || 0), 0) || 0
      setTotalPrice(totalMrp)

      // Set rawData with complete information
      setRawData({
        client: quoteDetails?.client || "",
        quotationitem: quoteDetails?.quotationitem || [],
      })

      // Document type mapping with additional types
      if (quoteDetails?.document_type) {
        const docTypeMap = {
          "quotation": { key: 1, label: "Quotation", value: "quotation" },
          "invoice": { key: 2, label: "Invoice", value: "invoice" },
          "proforma": { key: 3, label: "Proforma", value: "proforma" },
          "order": { key: 4, label: "Order", value: "order" }
        }
        setSelectedDocumentType(docTypeMap[quoteDetails.document_type] || {
          key: 1,
          label: "Quotation",
          value: "quotation",
        })
      }
      if (quoteDetails?.quotation_category) {
        setSelectedQuotationCategory({
          label: quoteDetails.quotation_category.charAt(0).toUpperCase() + quoteDetails.quotation_category.slice(1),
          value: quoteDetails.quotation_category
        })
      }
      if (quoteDetails?.care_of) {
        const careOfObj = {
          value: quoteDetails.care_of,
          staffName: quoteDetails.care_of_name || "",
          label: quoteDetails.care_of_name || "Care of Staff"
        }
        setSelectedCareOf(careOfObj)
        if (quoteDetails.care_of_name) {
          setLetterHead(prev => replaceCareOfNameInLetterHead(prev || quoteDetails?.letter_head, quoteDetails.care_of_name))
        }
      }
    }
  }, [quoteDetails])

  console.log(QProductPrice)

  // const percentages = QProductPrice?.profit
  const [percentageLast, setPercentageLast] = useState(0)

  useEffect(() => {
    if (quotationCurd?.id) {
      dispatch(getQuotationDetail(quotationCurd?.id))
    }
  }, [quotationCurd])


  useEffect(() => {
    dispatch(getClients(searchClientText, ""))
  }, [dispatch, searchClientText])

  useEffect(() => {
    dispatch(getProducts(searchText))
  }, [dispatch, searchText])

  const onAddFormRow = () => {
    if (editingItemId) {
      // Update existing item
      const modifiedRows = quotationitem.map(item => {
        if (item.id === editingItemId) {
          return {
            ...item,
            qty: qty,
            mrp: currentMrp,
            price: parseFloat(discountPrice).toFixed(2),
            totalPrice: parseFloat(totalPrice).toFixed(2),
            profit: percentageLast || 0,
            tax_amount: parseFloat(taxAmount).toFixed(2),
            tax_percentage: rowTaxPercentage,
            product: rawData.quotationitem.product || item.product,
            productName: rawData.quotationitem.productName || item.productName || item.product_name,
            item_name: rawData.quotationitem.item_name || item.item_name || null,
            item_type: rawData.quotationitem.item_type || item.item_type || "product",
            // Ensure we keep existing fields just in case
            product_name: rawData.quotationitem.productName || item.productName || item.product_name,
          }
        }
        return item
      })
      setQuotationitems(modifiedRows)
      setEditingItemId(null)
    } else {
      // Add new item
      const modifiedRows = [...quotationitem]
      // Safe ID generation
      // const maxId = modifiedRows.reduce((max, item) => (item.id > max ? item.id : max), 0)
      modifiedRows.push({
        id: modifiedRows.length + 1,
        qty: qty,
        mrp: currentMrp,
        price: parseFloat(discountPrice).toFixed(2),
        totalPrice: parseFloat(totalPrice).toFixed(2),
        profit: percentageLast || 0,
        tax_amount: parseFloat(taxAmount).toFixed(2),
        tax_percentage: rowTaxPercentage,
        ...rawData.quotationitem,
        item_name: rawData.quotationitem.item_name || null,
        item_type: rawData.quotationitem.item_type || "product",
      })
      setQuotationitems(modifiedRows)
    }

    setQty(1)

    // Only warn if adding new and missing data. For edit, we might assume data is there or validation handles it
    if (!editingItemId && (!rawData.client || !selectedProduct)) {
      Notification({
        type: "warning",
        message: "Please Select Client and Product",
        title: "Try Again",
      })
    }

    setTimeout(() => {
      handleClearStates()
    }, 1000)
  }

  console.log(quotationitem)

  const onDeleteFormRow = id => {
    if (id !== 0) {
      var modifiedRows = [...quotationitem]
      modifiedRows = modifiedRows.filter(x => x["id"] !== id)
      setQuotationitems(modifiedRows)
    }
  }

  const handleStatus = e => {
    setStatus(e)
  }
  useEffect(() => {
    setPercentageLast(QProductPrice?.profit || 0)
  }, [QProductPrice])

  useEffect(() => {
    setQty(1)
  }, [QProductPrice])


  useEffect(() => {
    setTotalPrice(parseFloat((parseFloat(discountPrice) + parseFloat(taxAmount)) * parseFloat(qty || 0)).toFixed(2) || 0)
  }, [discountPrice, qty, taxAmount])

  useEffect(() => {
    setTaxAmount(parseFloat((discountPrice * rowTaxPercentage) / 100).toFixed(2) || 0)
  }, [discountPrice, rowTaxPercentage])

  useEffect(() => {
    // Sync currentMrp when QProductPrice changes (new product selection)
    if (QProductPrice?.mrp) {
      setCurrentMrp(QProductPrice.mrp)
    }
  }, [QProductPrice])

  useEffect(() => {
    setRowDiscountPercentage(parseFloat(discount).toFixed(2) || 0)
    if (currentMrp && discount !== undefined && discount !== null) {
      const discountAmount = (currentMrp * parseFloat(discount)) / 100;
      const newDiscountPrice = currentMrp - discountAmount;
      setDiscountPrice(parseFloat(newDiscountPrice).toFixed(2) || 0);
    } else {
      setDiscountPrice(parseFloat(currentMrp || 0).toFixed(2) || 0);
    }
  }, [discount, currentMrp])


  useEffect(() => {
    setRowTaxPercentage(taxPercentage)
    // if (QProductPrice?.mrp && taxPercentage !== undefined && taxPercentage !== null) {
    //   const taxAmount = (QProductPrice.mrp * parseFloat(taxPercentage)) / 100;
    //   const newTaxPrice = QProductPrice.mrp + taxAmount;
    //   setTaxPrice(newTaxPrice);
    // } else {
    //   setTaxPrice(QProductPrice?.mrp || 0);
    // }
  }, [taxPercentage, QProductPrice?.mrp])

  // quotationitem
  const onSubmitQuotation = () => {
    dispatch(
      updateQuatation(
        {
          client: rawData.client,
          contact_person_phone: contact_person_phone,
          contact_person: contact_person,
          letter_head: letter_head,
          bank_details: bank_details,
          terms: terms,
          letter_middle: letter_middle,
          warrenty: warrenty,
          quotationitem,
          discount_percentage: parseFloat(discount),
          tax_percentage: parseFloat(taxPercentage),
          document_type: selectedDocumentType.value,
          quotation_category: selectedQuotationCategory.value,
          care_of: selectedCareOf ? selectedCareOf.value : null,
        },
        {
          client: rawData.client,
          contact_person_phone: contact_person_phone,
          contact_person: contact_person,
          letter_head: letter_head,
          bank_details: bank_details,
          terms: terms,
          letter_middle: letter_middle,
          warrenty: warrenty,
          quotationitem,
          discount_percentage: parseFloat(discount),
          tax_percentage: parseFloat(taxPercentage),
          document_type: selectedDocumentType.value,
          quotation_category: selectedQuotationCategory.value,
          care_of: selectedCareOf ? selectedCareOf.value : null,
        },
        quotationId,
        history
      )
    )
  }

  //setore item from and search
  function handlerFinalValue(selectedOption) {
    if (selectedOption) {
      if (selectedOption.__isNew__) {
        setSelectedProduct(selectedOption.label)
        setRawData({
          ...rawData,
          quotationitem: {
            product: null,
            productName: selectedOption.label,
            item_name: selectedOption.label,
            item_type: selectedQuotationCategory.value,
          },
        })
        setCurrentMrp(0)
        setDiscountPrice(0)
      } else {
        dispatch(getQProductPrice(selectedOption.value))
        setSelectedProduct(selectedOption.label)
        setRawData({
          ...rawData,
          quotationitem: {
            product: selectedOption.value,
            productName: selectedOption.label,
            item_name: null,
            item_type: "product",
          },
        })
      }
    } else {
      setSelectedProduct("")
    }
  }
  console.log(selectedProduct)

  const customFilterOption = (option, inputValue) => {
    return option.data.code.toLowerCase().includes(inputValue.toLowerCase())
  }

  const optionGroup1 = [
    {
      options: (products || [])?.map((result, index) => ({
        key: index,
        label: `${result.name} (${result.product_code})`,
        value: result?.id,
        data: result,
      })),
      filterOption: customFilterOption,
    },
  ]

  const debounceSearch = debounce(value => setSearchText(value), 600)

  const handleEnters = textEntered => {
    debounceSearch(textEntered)
  }

  function handlerClientFinalValue(event) {
    setSelectedClient(event)
    setRawData({
      ...rawData,
      ["client"]: event.value,
    })
  }

  function handleDocumentTypeChange(event) {
    setSelectedDocumentType(event)
    setRawData({
      ...rawData,
      ["document_type"]: event.value,
    })
  }

  const optionGroup2 = [
    {
      options: clients?.results?.map((result, index) => ({
        key: index,
        label: result.name,
        value: result.id,
      })),
    },
  ]

  const documentTypeOptions = [
    {
      options: [{
        key: 1,
        label: "Quotation",
        value: "quotation",
      },
      {
        key: 2,
        label: "Order",
        value: "order",
      }],
    },
  ]

  const categoryOptions = [
    {
      options: [
        { key: 1, label: "Product", value: "product" },
        { key: 2, label: "Service", value: "service" },
      ],
    },
  ]

  const handleClientEnters = textEntered => {
    setSearchClientText(textEntered)
  }

  const Role = sessionStorage.getItem("role")

  const disabledBtn = () => {
    if (rawData?.orderitem?.product && rawData?.client) {
      return true
    } else {
      return true
    }
  }


  const handleClearStates = () => {
    setSelectedProduct("")
    setQty(1)
    setRowDiscountPercentage(discount)
    setDiscountPrice(0)
    setTaxAmount(0)
    setRowTaxPercentage(taxPercentage)
    setCurrentMrp(0) 
    setTotalPrice(0)
    setPercentageLast(0)
    setRawData({
      ...rawData,
      quotationitem: {}
    })
  }


  const handleEdit = item => {
    console.log("Editing item:", item)

    // Set editing mode
    setEditingItemId(item.id)

    // Populate form fields with item data for editing
    const displayLabel = item?.productName && item.productName.includes("(") ? item.productName : (item?.product_code ? `${item?.product_name || item?.productName} (${item.product_code})` : (item?.productName || item?.product_name || ""));
    setSelectedProduct({
      label: displayLabel,
      value: item?.product || ""
    })
    // Also update rawData for product so onAddFormRow pulls correct new name if invalid
    setRawData(prev => ({
      ...prev,
      quotationitem: {
        product: item.product,
        productName: displayLabel
      }
    }))

    setQty(item?.qty || 1)

    // Set currentMrp strictly from the item being edited
    const itemMrp = parseFloat(item?.mrp || 0)
    setCurrentMrp(itemMrp)

    // Set the product data for price calculation values
    setDiscountPrice(item?.price || 0)

    // Calculate discount percentage based on mrp and price
    const price = parseFloat(item?.price || 0)
    const pct = itemMrp > 0 ? ((itemMrp - price) / itemMrp) * 100 : 0
    setRowDiscountPercentage(pct.toFixed(2))

    // Tax percentage
    setRowTaxPercentage(item?.tax_percentage || taxPercentage)
    setTaxAmount(item?.tax_amount || 0)

    setTotalPrice(item?.mrp_sub_total || item?.totalPrice || 0)

    // Set the product data for price calculation by fetching latest price if needed
    // Note: We deliberately do NOT fetch QProductPrice here to avoid resetting states. 
    // We rely on item data and currentMrp local state.
    if (item?.product) {
      // dispatch(getQProductPrice(item.product)) 
    }

    // We do NOT remove item from list, allowing Cancel to work without data loss.
    setIsOpen({ status: true, data: item })
  }

  const onCloseClick = () => {
    setIsOpen(false)
  }

  return (
    <>
      <MetaTags>
        <title>Update Quotation | Indtech </title>
      </MetaTags>

      <div className="page-content">
        <Breadcrumbs title="Quotation" breadcrumbItem="Update Quotation" />

        <Container fluid>
          <div className="container-fluid">
            {/* uploading */}
            <Row>
              <Col lg={1}></Col>
              <Col lg={10}>
                <Card>
                  <CardBody>
                    <CardTitle className="h4 mb-4">Quotation Details</CardTitle>

                    <Form className="repeater" encType="multipart/form-data">
                      <div>
                        <Row>
                          {Role == "client" ? (
                            <></>
                          ) : (
                            <Col lg={8} className="mb-1">
                              <FormGroup className="mb-1">
                                <Label>Client</Label>

                                <div className="col-md-12"></div>
                                <div className="mb-3 ajax-select mt-1 mt-lg-0 select2-container">
                                  <Select
                                    onInputChange={handleClientEnters}
                                    value={selectedClient}
                                    placeholder={selectedClient}
                                    onChange={handlerClientFinalValue}
                                    options={optionGroup2}
                                    classNamePrefix="select2-selection"
                                    isLoading={true}
                                    required={"required"}
                                  />
                                </div>
                              </FormGroup>
                            </Col>
                          )}
                          <Col lg={4} md={4} sm={12} className="">
                            <FormGroup className="mb-1">
                              <Label>Document type</Label>
                              <div className="col-md-12"></div>
                              <div className="mb-3 ajax-select mt-1 mt-lg-0 select2-container">
                                <Select
                                  // onInputChange={handleClientEnters}
                                  value={selectedDocumentType}
                                  placeholder={selectedDocumentType?.label}
                                  onChange={handleDocumentTypeChange}
                                  options={documentTypeOptions}
                                  classNamePrefix="select2-selection"
                                  isLoading={true}
                                  required={"required"}
                                />
                              </div>
                            </FormGroup>
                          </Col>
                          <Col lg={4} md={4} sm={12} className="">
                            <FormGroup className="mb-1">
                              <Label>Quotation Category</Label>
                              <div className="col-md-12"></div>
                              <div className="mb-3 ajax-select mt-1 mt-lg-0 select2-container">
                                <Select
                                  value={selectedQuotationCategory}
                                  placeholder={selectedQuotationCategory.label}
                                  onChange={(val) => setSelectedQuotationCategory(val)}
                                  options={categoryOptions}
                                  classNamePrefix="select2-selection"
                                  required={"required"}
                                />
                              </div>
                            </FormGroup>
                          </Col>
                          <Col lg={4} md={4} sm={12} className="">
                            <FormGroup className="mb-1">
                              <Label>Care of</Label>
                              <div className="col-md-12"></div>
                              <div className="mb-3 ajax-select mt-1 mt-lg-0 select2-container">
                                <Select
                                  value={selectedCareOf}
                                  placeholder="Select Care of Staff"
                                  onChange={handleCareOfChange}
                                  options={staffList.map(s => {
                                    const fullName = `${s.first_name || ''} ${s.last_name || ''}`.trim() || s.username
                                    return {
                                      value: s.id,
                                      staffName: fullName,
                                      label: `${fullName} (${s.username})`,
                                    }
                                  })}
                                  classNamePrefix="select2-selection"
                                  isClearable={true}
                                />
                              </div>
                            </FormGroup>
                          </Col>

                          <div className="col-4 pt-2">
                            <label>Contact Person</label>
                            <input
                              className="form-control"
                              type="text"
                              value={contact_person}
                              onChange={e => {
                                setContact_person(e.target.value)
                              }}
                            />
                          </div>
                          <div className="col-4 pt-2">
                            <label>Contact No</label>
                            <input
                              className="form-control"
                              type="tel"
                              value={contact_person_phone}
                              onChange={e => {
                                setContact_person_phone(e.target.value)
                              }}
                            />
                          </div>
                          <div className="col-2 pt-2">
                            <label>Discount %</label>
                            <input
                              className="form-control"
                              type="text"
                              value={discount}
                              onChange={e => {
                                setDiscount(e.target.value)
                              }}
                            />
                          </div>
                          <div className="col-2 pt-2">
                            <label>Tax %</label>
                            <input
                              className="form-control"
                              type="text"
                              value={taxPercentage}
                              onChange={e => {
                                setTaxPercentage(e.target.value)
                              }}
                            />
                          </div>

                        </Row>
                      </div>
                    </Form>

                  </CardBody>
                </Card>
              </Col>
              <Col lg={1}></Col>

              <Col lg={1}></Col>
              <Col lg={10}>
                <Card>
                  <CardBody>
                    <CardTitle className="h4 mb-4">
                      Quotation items{" "}
                    </CardTitle>
                    {loading ? (
                      <Spinner type="grow" color="gray" />
                    ) : (
                      <Form
                        className="repeater"
                        encType="multipart/form-data"
                      >
                        <Row>
                          <Col lg={4} md={4} sm={12} className="py-3">
                            <FormGroup className="">
                              <Label>Product</Label>
                              <div className="col-md-12"></div>
                              <div className="ajax-select mt-1 mb-3 mt-lg-0 select2-container">
                                <CreatableSelect
                                  onInputChange={handleEnters}
                                  value={
                                    selectedProduct
                                      ? typeof selectedProduct === "object"
                                        ? selectedProduct
                                        : { label: selectedProduct, value: selectedProduct }
                                      : null
                                  }
                                  placeholder={
                                    typeof selectedProduct === "object"
                                      ? selectedProduct?.label || "Search or type custom item..."
                                      : selectedProduct || "Search or type custom item..."
                                  }
                                  onChange={handlerFinalValue}
                                  options={optionGroup1}

                                // isLoading={true}
                                // required="required"
                                />
                              </div>

                            </FormGroup>
                          </Col>
                          <Col
                            lg={3}
                            md={3}
                            sm={12}
                            className="py-3"
                          >
                            <label htmlFor="profit-percentage">MRP</label>
                            <input
                              type="number"
                              className="form-control mt-1 mt-lg-0 border-secondary"
                              id="profit-percentage"
                              required
                              readOnly={rawData?.quotationitem?.product ? true : false}
                              value={currentMrp}
                              onChange={e => setCurrentMrp(e.target.value)}
                            />
                          </Col>
                          <Col
                            lg={2}
                            md={2}
                            sm={12}
                            className="py-3"
                          >
                            <label htmlFor="discount-percentage">Discount %</label>
                            <input
                              type="number"
                              className="form-control mt-1 mt-lg-0 border-secondary"
                              id="discount-percentage"
                              required
                              // readOnly
                              defaultValue={rowDiscountPercentage}
                              onChange={e => {
                                const val = e.target.value
                                setRowDiscountPercentage(val)
                                const discountAmount = (currentMrp * val) / 100
                                const newDiscountPrice = currentMrp - discountAmount
                                setDiscountPrice(parseFloat(newDiscountPrice).toFixed(2) || 0)
                              }}
                              value={rowDiscountPercentage}
                            />
                          </Col>
                          <Col
                            lg={3}
                            md={3}
                            sm={12}
                            className="py-3"
                          >
                            <label htmlFor="discount-price">Discount price</label>
                            <input
                              type="number"
                              className="form-control mt-1 mt-lg-0 border-secondary"
                              id="discount-price"
                              required
                              // readOnly
                              defaultValue={discountPrice}
                              value={discountPrice}
                              onChange={e => {
                                const val = e.target.value
                                setDiscountPrice(val)
                                const percentage =
                                  ((currentMrp - val) / currentMrp) * 100
                                setRowDiscountPercentage(parseFloat(percentage).toFixed(2) || 0)
                              }}
                            />
                          </Col>

                          <Col
                            lg={2}
                            md={2}
                            sm={12}
                            className="py-3"
                          >
                            <label htmlFor="tax-percentage">Tax %</label>
                            <input
                              type="number"
                              className="form-control mt-1 mt-lg-0 border-secondary"
                              id="tax-percentage"
                              required
                              // readOnly
                              defaultValue={rowTaxPercentage}
                              onChange={e => {
                                const val = e.target.value
                                setRowTaxPercentage(val)
                                // const taxAmount = (QProductPrice?.mrp * val) / 100
                                // const newTotalPrice = QProductPrice?.mrp + taxAmount
                                // setTaxAmount(taxAmount)
                                // setTotalPrice(newTotalPrice)
                              }}
                              value={rowTaxPercentage}
                            />
                          </Col>
                          <Col
                            lg={3}
                            md={3}
                            sm={12}
                            className="py-3"
                          >
                            <label htmlFor="tax-price">Tax amount</label>
                            <input
                              type="number"
                              className="form-control mt-1 mt-lg-0"
                              id="tax-price"
                              required
                              readOnly
                              defaultValue={taxAmount}
                              value={taxAmount}
                            // onChange={e => {
                            //   const val = e.target.value
                            //   setTaxAmount(val)
                            //   const percentage =
                            //     ((QProductPrice?.mrp - val) / QProductPrice?.mrp) * 100
                            //   setRowTaxPercentage(percentage)
                            // }}
                            />
                          </Col>

                          {selectedDocumentType["value"] == "order" ? (
                            <Col lg={1} md={1}></Col>
                          ) : (
                            <Col lg={3} md={3}></Col>
                          )}

                          {selectedDocumentType["value"] == "order" && (
                            <Col
                              lg={2}
                              md={2}
                              sm={12}
                              className="py-3"
                            >
                              <label htmlFor="qty">Quantity</label>
                              <input
                                type="number"
                                className="form-control mt-1 mt-lg-0 border-secondary"
                                id="qty"
                                required
                                min={0}
                                defaultValue={qty}
                                onChange={e => setQty(e.target.value)}
                                value={qty}
                              />
                            </Col>)}

                          <Col lg={4} md={4} sm={12} className="py-3">
                            <label htmlFor="total-price">Total Price</label>
                            <input
                              type="number"
                              className="form-control mt-1 mt-lg-0 text-warning"
                              id="total-price"
                              required
                              value={totalPrice}
                              readOnly
                            // onChange={e => handleTotal(e)}
                            />
                          </Col>

                          <Col
                            lg={12}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: "10px"
                            }}
                          >
                            {editingItemId && (
                              <input
                                type="button"
                                className="btn btn-secondary"
                                value="Cancel Edit"
                                onClick={() => {
                                  setEditingItemId(null)
                                  handleClearStates()
                                }}
                              />
                            )}
                            <input
                              type="button"
                              className={`btn ${editingItemId ? 'btn-warning' : 'btn-dark'} mr-lg-0 ${disabledBtn() == false && "disabled"
                                }`}
                              value={editingItemId ? "Update Item" : "Add to Quotation"}
                              onClick={() => onAddFormRow()}
                              style={{
                                pointerEvents:
                                  rawData.product == false && "none",
                              }}
                            />
                          </Col>
                        </Row>

                        {quotationitem?.length > 0 && (
                          <div>

                            <Row className="text-muted mt-4">
                              <Col lg={4} md={4}>
                                <h6>Product :</h6>
                              </Col>
                              {/* <Col lg={2} md={2}>
                                <h6>Mrp :</h6>
                              </Col> */}
                              <Col lg={2} md={2}>
                                <h6>Price :</h6>
                              </Col>
                              <Col lg={2} md={2}>
                                <h6>Tax :</h6>
                              </Col>
                              {selectedDocumentType["value"] == "order" && (
                                <Col lg={1} md={1}>
                                  <h6>Qty :</h6>
                                </Col>
                              )}
                              <Col lg={2} md={2}>
                                <h6>Total :</h6>
                              </Col>
                              <Col
                                lg={1}
                                md={1}
                                className="align-self-start"
                              >
                              </Col>
                            </Row>

                            {map(quotationitem, (item, index) => (
                              <Row key={index} className="text-muted mt-4">
                                <Col lg={4} md={4}>
                                  <p>
                                    <i className="mdi mdi-chevron-right text-primary me-1" />
                                    {item?.productName && item.productName.includes("(") ? item.productName : (item?.product_code ? `${item?.product_name || item?.productName} (${item.product_code})` : (item?.productName || item?.product_name || ""))}
                                  </p>
                                </Col>

                                <Col lg={2} md={2}>
                                  {item?.mrp !== item?.price ? (
                                    <>
                                      <small className="text-black font-size-10 text-decoration-line-through">
                                        {parseFloat(item?.mrp).toFixed(2)}
                                      </small><br />
                                    </>
                                  ) : null}
                                  <p>{item?.price}</p>
                                </Col>

                                <Col lg={2} md={2}>
                                  <p>{`${item?.tax_amount}(${item?.tax_percentage}%)`}</p>
                                </Col>
                                {selectedDocumentType["value"] == "order" && (
                                  <Col lg={1} md={1}>
                                    <p>
                                      {item?.qty}</p>
                                  </Col>
                                )}
                                <Col lg={2} md={2}>
                                  <p>
                                    {item?.totalPrice ? item?.totalPrice : parseFloat((parseFloat(item?.price) +
                                      parseFloat(item?.tax_amount)) * parseFloat(item?.qty)
                                    ).toFixed(2)}
                                  </p>
                                </Col>

                                <Col
                                  lg={1}
                                  md={1}
                                  className="align-self-start"
                                >
                                  <div
                                    className="d-flex gap-2"
                                    style={{ maxWidth: "200px" }}
                                  >
                                    <i
                                      style={{ cursor: "pointer" }}
                                      className="bx bx-edit font-size-18 text-info"
                                      onClick={() => handleEdit(item)}
                                      title="Edit"
                                    ></i>
                                    <i
                                      style={{ cursor: "pointer" }}
                                      className="fa fa-trash mt-1 mr-lg-0 text-danger"
                                      onClick={() =>
                                        onDeleteFormRow(item.id)
                                      }
                                      title="Delete"
                                    ></i>
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        )}
                      </Form>
                    )}
                  </CardBody>
                </Card>
              </Col>
              <Col lg={1}></Col>

              <Col lg={1}></Col>
              <Col lg={10}>
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4">{activeTab.title}</h4>

                    <Nav pills className="bg-light rounded" role="tablist">
                      <NavItem className="mx-2">
                        <NavLink
                          className={classnames({
                            active: activeTab.id === "1",
                          })}
                          onClick={() => {
                            setactiveTab({
                              ...activeTab,
                              id: "1",
                            })
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-end">
                            Letter Head
                            <i className="bx bx-chevrons-right font-size-20 mx-2"></i>
                          </div>
                        </NavLink>
                      </NavItem>
                      <NavItem className="mx-2">
                        <NavLink
                          className={classnames({
                            active: activeTab.id === "2",
                          })}
                          onClick={() => {
                            setactiveTab({
                              ...activeTab,
                              id: "2",
                            })
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-end">
                            Bank Details
                            <i className="bx bx-chevrons-right font-size-20 mx-2"></i>
                          </div>
                        </NavLink>
                      </NavItem>
                      <NavItem className="mx-2">
                        <NavLink
                          className={classnames({
                            active: activeTab.id === "3",
                          })}
                          onClick={() => {
                            setactiveTab({
                              ...activeTab,
                              id: "3",
                            })
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-end">
                            Terms and Conditions
                            <i className="bx bx-chevrons-right font-size-20 mx-2"></i>
                          </div>
                        </NavLink>
                      </NavItem>
                      <NavItem className="mx-2">
                        <NavLink
                          className={classnames({
                            active: activeTab.id === "4",
                          })}
                          onClick={() => {
                            setactiveTab({
                              ...activeTab,
                              id: "4",
                            })
                          }}
                        >
                          Warranty clause
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab.id} className="mt-4">
                      <TabPane tabId="1">
                        {activeTab.id === "1" && (
                          <>
                            <FormEditors
                              content={letter_head}
                              setEditedContent={setLetterHead}
                            />

                            <div className="d-flex align-items-center justify-content-end mt-2">
                              <button
                                className="btn btn-light w-fit-content d-flex align-items-center justify-content-center"
                                onClick={() => {
                                  setactiveTab({
                                    ...activeTab,
                                    id: "2",
                                  })
                                }}
                              >
                                Next
                                <i className="bx bx-chevrons-right bx-fade-right font-size-20"></i>
                              </button>
                            </div>
                          </>
                        )}
                      </TabPane>

                      <TabPane tabId="2">
                        {activeTab.id === "2" && (
                          <Form method="post">
                            <FormEditors
                              content={bank_details ? bank_details : ""}
                              setEditedContent={setBankDetails}
                            />
                            <textarea
                              rows="5"
                              type="text"
                              className="form-control mt-4 pt-4"
                              id=""
                              placeholder={"We are expecting your valuable...."}
                              value={letter_middle}
                              onChange={e => setLetter_middle(e.target.value)}
                            />
                            <div className="d-flex align-items-center justify-content-end mt-2">
                              <button
                                className="btn btn-light w-fit-content d-flex align-items-center justify-content-center"
                                onClick={() => {
                                  setactiveTab({
                                    ...activeTab,
                                    id: "3",
                                  })
                                }}
                              >
                                Next
                                <i className="bx bx-chevrons-right bx-fade-right font-size-20"></i>
                              </button>
                            </div>
                          </Form>
                        )}
                      </TabPane>
                      <TabPane tabId="3">
                        {activeTab.id === "3" && (
                          <>
                            <FormEditors
                              content={terms ? terms : ""}
                              setEditedContent={setTerms}
                            />
                            <div className="d-flex align-items-center justify-content-end mt-2">
                              <button
                                className="btn btn-light w-fit-content d-flex align-items-center justify-content-center"
                                onClick={() => {
                                  setactiveTab({
                                    ...activeTab,
                                    id: "4",
                                  })
                                }}
                              >
                                Next
                                <i className="bx bx-chevrons-right bx-fade-right font-size-20"></i>
                              </button>
                            </div>
                          </>
                        )}
                      </TabPane>
                      <TabPane tabId="4">
                        {activeTab.id === "4" && (
                          <>
                            <FormEditors
                              content={warrenty ? warrenty : ""}
                              setEditedContent={setWarrantyClause}
                            />
                            <div>
                              <Row>
                                <Col lg="6" md="6"></Col>
                                <Col lg="3" md="3">
                                  {quotationCurd?.id && (
                                    <div className="text-sm-end mt-2">
                                      <Link
                                        to={`/quotation/pdf/${quotationCurd?.id}`}
                                        type="button"
                                        className="btn btn-outline-light d-flex mt-4 w-auto"
                                        style={{
                                          marginLeft: "auto",
                                          alignItems: "center",
                                          width: "fit-content",
                                          border: "1px solid #cccc",
                                        }}
                                      >
                                        PDF
                                        <i className="mdi mdi-download d-block font-size-16 mx-1"></i>
                                      </Link>
                                    </div>
                                  )}
                                </Col>
                                <Col lg="3" md="3">
                                  <div className="text-sm-end mt-2">
                                    <Link
                                      to="#"
                                      className="btn btn-success"
                                      onClick={onSubmitQuotation}
                                    >
                                      Confirm Quotation
                                      {quotationLoading ? (
                                        <>
                                          <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                                        </>
                                      ) : (
                                        <i className="mdi mdi-truck-fast mx-2" />
                                      )}
                                    </Link>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </>
                        )}
                      </TabPane>
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>

              <Col lg={1}></Col>
            </Row>
          </div>
        </Container >
        {/* <EditModal
          show={isOpen?.status}
          onCloseClick={onCloseClick}
          data={isOpen?.data}
        /> */}
      </div >
    </>
  )
}

export default UpdateQuotations

UpdateQuotations.propTypes = {
  history: PropTypes.object,
}
